import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import appInfo from './modules/app/appInfo'
import appTreeData from './modules/app/appTreeData'
import applicationLinkTree from './modules/app/applicationLinkTree'

import formConfig from './modules/app/formConfig'
import appItem from './modules/app/appItem'

import user from './modules/org/user'
import unit from './modules/org/unit'

// import permission from './modules/org/permission'
import getters from './modules/getters'
import errLog from './modules/errLog'
import app from './modules/app'


export default new Vuex.Store({
  modules: {
    appInfo,
    appTreeData,
    applicationLinkTree,


    formConfig,
    appItem,

    user,

    errLog,
    permission:{},
    app
  },
  getters
})




// WEBPACK FOOTER //
// ./src/common/vuex/store_rt.js